import Constants from "../../Action/Constants";

export const downloadGlobalCharges = (
  ownerId, 
  year, 
  lng,
  userlng,
  { onSuccess = undefined, onError = undefined } = { onSuccess: undefined, onError: undefined }
) => ({
  type: Constants.GLOBAL_CHARGES_DOWNLOAD_START,
  payload: { ownerId, year, lng, userlng },
  onSuccess,
  onError,
});